var _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLightMixer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1307,
    height: 1307,
    viewBox: "0 0 1307 1307",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    filter: "url(#filter0_f_3200_698)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 653.615,
    cy: 653.615,
    r: 277.615,
    fill: "#990CE8"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    filter: "url(#filter1_f_3200_698)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 653.648,
    cy: 653.31,
    rx: 180.883,
    ry: 180.881,
    fill: "#D500FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_3200_698",
    x: 0.945221,
    y: 0.945221,
    width: 1305.34,
    height: 1305.34,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 187.527,
    result: "effect1_foregroundBlur_3200_698"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_3200_698",
    x: 365.607,
    y: 365.271,
    width: 576.083,
    height: 576.079,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 53.5793,
    result: "effect1_foregroundBlur_3200_698"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightMixer);
export default __webpack_public_path__ + "static/media/light-mixer.c7eb5cccaf86c2fec066ca28f917bc73.svg";
export { ForwardRef as ReactComponent };